import { Box, type BoxProps } from '@chakra-ui/react';
import {
  AutomationPreviewBody,
  type AutomationPreviewBodyProps,
} from './AutomationPreviewBody';

export type AutomationPreviewFieldProps = AutomationPreviewBodyProps & {
  // Gate the whole block (including its spacer Box) — render nothing when the
  // target stage has no automation and there's nothing to stop.
  show?: boolean;
  // Spread onto the wrapping Box (e.g. `{ mt: '16px' }` for the modal spacing).
  containerProps?: BoxProps;
  // Injected by FormItem when this is used as a `type: 'custom'` field; unused.
  formik?: unknown;
};

// Adapts `AutomationPreviewBody` for use as a FormBuilder `type: 'custom'` field
// so the automation preview can sit BETWEEN the stage picker and later fields
// (e.g. the "Change source and credited to" toggle) instead of below the whole
// form. Kept a stable top-level component — FormItem renders `<field.Field/>`,
// so an inline arrow in the config would remount it on every render.
export const AutomationPreviewField = ({
  show = true,
  containerProps,
  formik: _formik,
  ...bodyProps
}: AutomationPreviewFieldProps) => {
  if (!show) return null;
  return (
    <Box {...containerProps}>
      <AutomationPreviewBody {...bodyProps} />
    </Box>
  );
};
